import {Component, OnInit} from '@angular/core';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentManagerService} from 'src/app/services/document-manager/document-manager.service';
import {formatDate} from '@angular/common';
import {GridOptions} from "ag-grid-community";

@Component({
    selector: 'app-doc-mgmt-report',
    templateUrl: './doc-mgmt-report.component.html',
    styleUrls: ['./doc-mgmt-report.component.css'],
    standalone: false
})
export class DocMgmtReportComponent implements OnInit {
  gridOptions: GridOptions = this.initializeGridOptions();
  docMgmtRptColumnDefs = [
    {
      headerName: 'File Name', field: 'fileName', filter: 'agTextColumnFilter', sortable: true, width: 150,
      cellClass: 'textFormat'
    },
    {headerName: 'Document Status', field: 'documentStatus', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Document Type', field: 'documentType', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'SCAC', field: 'scac', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Update By', field: 'updatedBy', filter: 'agTextColumnFilter', sortable: true},
    {
      headerName: 'Effective Date', field: 'effectiveDate',
      valueGetter: (params) => {
        return params.data.effectiveDate ? (formatDate(params.data.effectiveDate, this.format, this.locale)) :
          ( params.data.effectiveDate === null  && params.data.fileName === null) ? '' : 'Always Effective';
      }, filter: 'agTextColumnFilter', sortable: true
    },
    {
      headerName: 'Expiry Date', field: 'expiryDate',
      valueGetter: (params) => {
        return params.data.expiryDate ? (formatDate(params.data.expiryDate, this.format, this.locale)) :
          (params.data.expiryDate === null && params.data.fileName === null) ? '' : 'No Expiration';
      }, filter: 'agTextColumnFilter', sortable: true
    },
    {headerName: 'Updated Date', field: 'updateDate', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Approval/Rejections Comments', field: 'approvalComments', filter: 'agTextColumnFilter', sortable: true},
    {headerName: 'Additional Comments', field: 'additionalComments', filter: 'agTextColumnFilter', sortable: true}

  ];
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];
  documentManagementList: any = [{}];
  businessType: any;
  format = 'MM/dd/yyyy';
  locale = 'en-US';

  public errorMessage = '';
  order = 'faic';
  reverse = false;

  private strloader;
  paginationPageSize;
  domLayout;
  faicListDetails = [
    {}
  ];

  constructor(
    private alertService: AlertService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private documentManagerService: DocumentManagerService,
    private router: Router) {
    this.paginationPageSize = 25;
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      rowClassRules: {
        //  'new-carrier': 'data.scac.indexOf("New") > -1 ',

        'new-carrier': function (params) {
          return !params.data.fileName ;
        },
        'doc-expired': function (params) {
          return !(params.data.expiryDate && params.data.fileName) ? false : new Date(params.data.expiryDate) < new Date();
        }
      },
      defaultCsvExportParams: {
        fileName: 'Document_Management_Report'
      },
      defaultExcelExportParams: {
        fileName: 'Document_Management_Report'
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  ngOnInit() {
    this.businessType = this.route.snapshot.queryParams['businessType'];
    this.appendBusinessTypeOnExportFileName();
    
    this.onSearch();
  }

  onSearch() {

    this.loadingService.show();
    // call to server for data.  Results will be stored in faicListDetails.
    this.documentManagerService.getDocumentsByBusinessType(this.businessType)
      .subscribe(data => {
          this.documentManagementList = data;
        },
        (error) => {
          this.errorMessage = error;
          console.log('No records found for the search criteria: ' + error);
          this.alertService.error('No records found for the search criteria ');
          this.loadingService.hide();
        }, () => {
          console.log('Successfully retrieved document report details: ', this.faicListDetails);
          this.loadingService.hide();
        }
      );
  }

  goBack() {
    this.router.navigate(['/documentmanagement'],
      {
        queryParams: {
          businessTypeBack: [this.businessType]
        }
      });
  }


  appendBusinessTypeOnExportFileName() {
    //get typeOf business type query param
    //on intial load business type is array instance - refresh load string instance
    if (this.businessType && Array.isArray(this.businessType)) {
      this.appendBusinessType(this.businessType[0]);
    } else if (this.businessType && typeof this.businessType === "string") {
      this.appendBusinessType(this.businessType);
    }
  }

  appendBusinessType(businessType: string) {
    if (this.gridOptions 
      && this.gridOptions.defaultCsvExportParams 
      && this.gridOptions.defaultCsvExportParams.fileName) {
        this.gridOptions.defaultCsvExportParams.fileName = businessType.toUpperCase() +"_"+this.gridOptions.defaultCsvExportParams.fileName;
    }
    if (this.gridOptions 
      && this.gridOptions.defaultExcelExportParams 
      && this.gridOptions.defaultExcelExportParams.fileName) {
        this.gridOptions.defaultExcelExportParams.fileName = businessType.toUpperCase() +"_"+this.gridOptions.defaultExcelExportParams.fileName;
    }
  }
}
